import { render, staticRenderFns } from "./MetierEdit.vue?vue&type=template&id=3b62cd85&"
import script from "./MetierEdit.vue?vue&type=script&lang=js&"
export * from "./MetierEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports